export type ErrorPageConfig = {
  title: string;
  message: string;
  iconSvg: string;
  primaryActionLabel?: string;
};

const FIRST_ACCESSIBLE_ROUTE_KEY = "FirstAccessibleRoute";

export function renderErrorPage(
  container: HTMLElement,
  config: ErrorPageConfig
): void {
  const primaryActionLabel = config.primaryActionLabel ?? "Back to Home";

  container.innerHTML = `
    <div class="error-page-shell">
      <section class="error-page-card" role="status" aria-live="polite">
        <div class="error-page-icon" aria-hidden="true">
          ${config.iconSvg}
        </div>

        <h1 class="error-page-title">${config.title}</h1>

        <div class="error-page-message">${config.message}</div>

        <button type="button" class="error-page-button" id="go-home">
          ${primaryActionLabel}
        </button>
      </section>
    </div>
  `;

  container
    .querySelector<HTMLButtonElement>("#go-home")
    ?.addEventListener("click", () => {
      navigateWithoutReload(getHomeRoute());
    });
}

function navigateWithoutReload(path: string): void {
  const singleSpa = (
    window as Window & {
      singleSpa?: { navigate?: (path: string) => void };
    }
  ).singleSpa;

  if (singleSpa?.navigate) {
    singleSpa.navigate(path);
    return;
  }

  window.history.pushState(null, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

function getHomeRoute(): string {
  const homeRoute = sessionStorage.getItem(FIRST_ACCESSIBLE_ROUTE_KEY);
  return homeRoute || "/";
}
